import { SELECT_DICTIONARY } from '../constants/dictionary.constant';

export const getReason = (selectValue, textAreaValue) => (selectValue === SELECT_DICTIONARY.others ? textAreaValue : selectValue);
